import {
  activeFlagColumnDefinition,
  companyCodeColumnDefinition,
  connNameColumnDefinition,
  legalEntityColumnDefinition,
  leLocalTaxTypeColumnDefinition,
  leUsTaxTypeColumnDefinition,
  ownershipColumnDefinition,
  tbeCompanyCodeColumnDefinition,
  tbeLegalEntityColumnDefinition,
  tbeTypeColumnDefinition,
  diagnosticsSeverityColumnDefinition,
  diagnosticColumnDefinition,
  diagnosticWithTooltipColumnDefinition,
  importValidationColumnDefinition,
} from '../columnDefinitions';

const taxBookingEntitiesColumnDefinitions = [
  diagnosticsSeverityColumnDefinition,
  diagnosticWithTooltipColumnDefinition,
  companyCodeColumnDefinition,
  connNameColumnDefinition,
  legalEntityColumnDefinition,
  leUsTaxTypeColumnDefinition,
  leLocalTaxTypeColumnDefinition,
  tbeCompanyCodeColumnDefinition,
  tbeLegalEntityColumnDefinition,
  tbeTypeColumnDefinition,
  ownershipColumnDefinition,
  activeFlagColumnDefinition,
];

export default taxBookingEntitiesColumnDefinitions;

export const exportTaxBookingEntitiesColumnDefinitions = [
  { ...importValidationColumnDefinition, field: 'importValidation' },
  diagnosticsSeverityColumnDefinition,
  diagnosticColumnDefinition,
  ...taxBookingEntitiesColumnDefinitions.slice(2),
];
